import React, { useContext, useState, useEffect } from "react";
import { API } from "src/shared/api/api";
import { Categories } from "src/enitities/Table";
import { CategoriesContext } from "src/shared/lib/hooks/context/getCategoriesContext";
import { addRow, removeRow, saveRow } from "src/shared";

export default function TableCategories() {
  const { token, websocket, data, pathname } = useContext(CategoriesContext);
  const [dataSource, setDataSource] = useState(data);

  useEffect(() => {
    if (data) {
      setDataSource(data);
    }
  }, [data]);

  useEffect(() => {
    websocket.onmessage = (message) => {
      const data = JSON.parse(message.data);
      if (data.target === "categories") {
        if (data.action === "create") {
          addRow(dataSource, data.result, setDataSource);
        }
        if (data.action === "edit") {
          saveRow(dataSource, data.result, setDataSource);
        }
        if (data.action === "delete") {
          removeRow(dataSource, data.result.id, setDataSource);
        }
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, dataSource, websocket.readyState]);

  return (
    <Categories
      dataSource={dataSource}
      handleSave={API.crud.edit(token, pathname)}
      handleRemove={API.crud.remove(token, pathname)}
    />
  );
}
